import React from 'react';
import { TooltipRenderProps } from 'react-joyride';
import { defineMessages } from '@vistaprint-org/digital-i18n-utils';
import { useTranslation } from 'react-i18next';
import {
  Banner,
  BannerDescription,
  BannerDisplay,
  BannerImage,
  BannerImageContainer,
  BannerLinks,
  BannerText,
  BannerTextContainer,
  Button,
  FluidImage,
  Link,
  Typography,
} from '@vp/swan';
import './WelcomeDialog.scss';

const messages = defineMessages({
  header: 'Create your landing page',
  text: 'This is where you’ll customize the experience your users will see once they access your online landing page.',
  confirmButton: 'Learn how to get started',
  skipTourButton: 'Skip tour',
  welcomeDialogImageAlt: 'Example landing pages displayed on mobile phones',
});

const WelcomeDialog: React.FC<TooltipRenderProps> = (props: TooltipRenderProps) => {
  const { primaryProps, tooltipProps, skipProps } = props;
  const { t } = useTranslation();

  return (
    <Banner variant="card" className="welcome-dialog" {...tooltipProps}>
      <BannerImageContainer>
        <BannerImage>
          <FluidImage
            src={`${window.vbcConfig.host}/images/welcomeDialog.png`}
            alt={t(messages.welcomeDialogImageAlt.id)}
          />
        </BannerImage>
      </BannerImageContainer>
      <BannerTextContainer>
        <BannerText>
          <BannerDisplay>{t(messages.header.id)}</BannerDisplay>
          <BannerDescription>
            <p>{t(messages.text.id)}</p>
          </BannerDescription>
          <BannerLinks className="welcome-dialog__buttons">
            <Button skin="primary" {...primaryProps} marginRight={'5'}>
              {t(messages.confirmButton.id)}
            </Button>
            <Link
              className="welcome-dialog__skip-tour-button"
              paddingY={'5'}
              as="button"
              {...skipProps}
            >
              <Typography fontSize="xsmall">{t(messages.skipTourButton.id)}</Typography>
            </Link>
          </BannerLinks>
        </BannerText>
      </BannerTextContainer>
    </Banner>
  );
};

export default WelcomeDialog;
